import { createFileRoute, Link } from "@tanstack/react-router";
import { ContentPage, ContentSection } from "../components/content/ContentPage";

const COMPANY = "FRUIT CREATIVE S.R.L.";
const CUI = "RO39066744";
const CONTACT_EMAIL = "contact@suuper.ro";
const LAST_UPDATED = "12 august 2026";

export const Route = createFileRoute("/termeni")({
  head: () => ({
    meta: [
      { title: "Termeni și condiții — suuper" },
      {
        name: "description",
        content:
          "Condițiile în care poți folosi suuper: înscrierea pe listă, prețurile de membru, obligațiile părților.",
      },
      { name: "robots", content: "index, follow" },
    ],
  }),
  component: TermsPage,
});

function TermsPage() {
  return (
    <ContentPage
      title="Termeni și condiții"
      eyebrow="DOCUMENT LEGAL"
      meta={`Ultima actualizare: ${LAST_UPDATED}`}
      intro={
        <>
          suuper este în perioada de dinaintea lansării. Înscrierea pe listă este
          gratuită și nu te obligă la nimic. Documentul de mai jos explică ce
          promitem și ce nu, ca să nu existe surprize.
        </>
      }
    >
      <ContentSection id="parti" title="1. Cine oferă serviciul">
        <p>
          suuper este operat de <strong>{COMPANY}</strong>, CUI {CUI}. Folosind
          site-ul sau aplicația, ești de acord cu termenii de mai jos. Dacă nu
          ești, te rugăm să nu le folosești.
        </p>
      </ContentSection>

      <ContentSection id="serviciu" title="2. Ce este suuper">
        <p>
          suuper este o comunitate de cumpărare. Adunăm cererea mai multor
          persoane și negociem, în numele lor, prețuri pentru produse și servicii
          la comercianți parteneri. Prețul negociat devine disponibil membrilor,
          în aplicație.
        </p>
        <p>
          suuper nu vinde produsele partenerilor și nu este parte în contractul
          dintre tine și comerciant. Vânzătorul rămâne partenerul, iar reclamațiile
          privind produsul, livrarea sau garanția se adresează acestuia.
        </p>
      </ContentSection>

      <ContentSection id="lista" title="3. Înscrierea pe listă">
        <p>
          Înscrierea pe lista de dinaintea lansării este gratuită, nu cere datele
          cardului și nu te obligă să cumperi nimic. Îți scriem despre lansare și
          despre prețurile deblocate pentru comunitate. Te poți dezabona oricând,
          din linkul aflat în fiecare email.
        </p>
        <p>
          Locul pe listă nu îți garantează acces la o anumită ofertă și nu
          reprezintă o rezervare de produs.
        </p>
      </ContentSection>

      <ContentSection id="preturi" title="4. Prețuri și exemple">
        <p>
          Prețurile afișate pe paginile publice înainte de lansare sunt{" "}
          <strong>exemple demonstrative</strong>, marcate ca atare. Ele arată cum
          va funcționa experiența și nu constituie ofertă comercială.
        </p>
        <p>
          O ofertă devine reală doar după activarea parteneriatului și apare în
          aplicație cu prețul, perioada și condițiile ei. Ofertele pot avea un
          număr limitat de utilizări și o perioadă de valabilitate, stabilite
          împreună cu partenerul.
        </p>
        <p>
          Nu garantăm că un anumit preț va fi disponibil, nici că va rămâne
          neschimbat. Când o ofertă se epuizează sau expiră, dispare din aplicație.
        </p>
      </ContentSection>

      <ContentSection id="cont" title="5. Contul tău">
        <p>
          Ești responsabil de păstrarea în siguranță a accesului la cont și de
          activitatea desfășurată prin el. Contul este personal și nu poate fi
          transferat sau folosit de altcineva.
        </p>
        <p>
          Putem suspenda sau închide un cont folosit abuziv: încercări de fraudă,
          multiplicarea artificială a conturilor, folosirea automatizată a
          ofertelor sau orice comportament care prejudiciază partenerii ori
          ceilalți membri.
        </p>
      </ContentSection>

      <ContentSection id="abonament" title="6. Abonamente și plăți">
        <p>
          Dacă vei alege un abonament plătit, prețul și perioada îți sunt afișate
          înainte de plată. Plățile sunt procesate de Stripe; noi nu avem acces la
          datele cardului tău.
        </p>
        <p>
          Ca și consumator, ai dreptul legal de retragere în 14 zile pentru
          serviciile achiziționate la distanță, în condițiile prevăzute de OUG
          34/2014. Dacă ai cerut expres începerea serviciului în acest interval și
          l-ai folosit, poți datora contravaloarea proporțională a perioadei
          utilizate.
        </p>
      </ContentSection>

      <ContentSection id="parteneri" title="7. Pentru parteneri">
        <p>
          Trimiterea formularului de parteneriat nu creează un contract. Condițiile
          concrete — prețul de membru, plafonul de utilizări, perioada și
          categoriile — se stabilesc separat, în scris, iar nimic nu devine activ
          fără acordul partenerului.
        </p>
      </ContentSection>

      <ContentSection
        id="continut-vizual"
        title="8. Conținut vizual generat cu inteligență artificială"
      >
        <p>
          O parte dintre imaginile folosite pe acest site — fotografiile de
          atmosferă, cardul de membru și ilustrațiile din secțiunea de noutăți —
          sunt <strong>generate cu instrumente de inteligență artificială</strong>.
          Le marcăm ca atare pentru transparență, conform obligațiilor din
          Regulamentul (UE) 2024/1689 privind inteligența artificială.
        </p>
        <p>
          Aceste imagini sunt ilustrative. Persoanele care apar în ele nu sunt
          persoane reale, nu sunt membri sau parteneri suuper și nu constituie
          mărturii ori recomandări. Locațiile și produsele vizibile nu reprezintă
          parteneriate existente.
        </p>
        <p>
          Nu folosim imagini generate artificial pentru a reprezenta oferte reale,
          prețuri reale sau persoane identificabile.
        </p>
      </ContentSection>

      <ContentSection id="raspundere" title="9. Limitarea răspunderii">
        <p>
          Depunem eforturi rezonabile pentru ca serviciul să funcționeze corect,
          dar nu îl putem garanta neîntrerupt sau lipsit de erori. Nu răspundem
          pentru calitatea produselor și serviciilor oferite de parteneri, pentru
          refuzul unui partener de a onora o ofertă din motive care nu ne sunt
          imputabile, ori pentru pierderi indirecte.
        </p>
        <p>
          Nimic din acest document nu limitează drepturile pe care legislația
          privind protecția consumatorilor ți le acordă în mod imperativ.
        </p>
      </ContentSection>

      <ContentSection id="modificari" title="10. Modificări">
        <p>
          Putem actualiza acești termeni. Modificările importante sunt anunțate
          prin email sau pe site înainte să intre în vigoare. Continuarea folosirii
          serviciului după intrarea lor în vigoare înseamnă acceptare.
        </p>
      </ContentSection>

      <ContentSection id="lege" title="11. Legea aplicabilă și contact">
        <p>
          Acestor termeni li se aplică legea română. Litigiile se soluționează
          amiabil, iar dacă nu e posibil, de instanțele competente din România. Ca
          și consumator, te poți adresa ANPC sau platformei europene de
          soluționare online a litigiilor.
        </p>
        <p>
          Ne poți scrie oricând la{" "}
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className="font-medium text-primary hover:underline"
          >
            {CONTACT_EMAIL}
          </a>
          . Vezi și{" "}
          <Link
            to="/confidentialitate"
            className="font-medium text-primary hover:underline"
          >
            politica de confidențialitate
          </Link>
          .
        </p>
      </ContentSection>
    </ContentPage>
  );
}
